import { useSlateElementEdit } from "../common/useSlateElementEdit";

export interface IFootnote {
  footnote_text?: string;
  label?: string;
}

export const useFootnoteEdit = () => {
  return useSlateElementEdit<IFootnote>(element => ({
    footnote_text: (element as any).footnote_text,
    label: (element as any).label,
  }));
};

export type FootnoteEditData = ReturnType<typeof useFootnoteEdit>;